'use strict'

angular
  .module('basalteApp')
  .constant('BAS_STORED_SERVERS', {
    EVT_STORED_CORES_UPDATED: 'evtBasStoredCoresUpdated'
  })
